module.exports = __webpack_public_path__ + "static/media/4.bd39b07a.jpg";